/**
 * <TutorPrepareLiveSkeleton> — la forme de « Préparer mon live » au chargement : Sam et sa bulle,
 * puis un live — son jour et son anneau, et deux élèves avec ce qu'il faut leur choisir. Le cas
 * courant : un cours partagé à deux.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { ChampionAvatar } from "../../atoms/Avatar/ChampionAvatar"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"
import { CardList, CardListRow } from "../../molecules/CardList"
import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"

export function TutorPrepareLiveSkeleton() {
    return (
        <Stack gap="5">
            <Row gap="3" align="start">
                <ChampionAvatar name="sam" size={54} />
                <Card background="surface-subtle" elevation="none" p="3" style={styles.bubble}>
                    <Stack gap="1">
                        <Skeleton textSize="text-base" width="90%" />
                        <Skeleton textSize="text-base" width="60%" />
                    </Stack>
                </Card>
            </Row>
            <CardList>
                <CardListRow>
                    <Row justify="between" align="center">
                        <Skeleton textSize="text-md" width={170} />
                        <Skeleton shape="circle" size={48} />
                    </Row>
                </CardListRow>
                {[0, 1].map((index) => (
                    <CardListRow key={index} divided>
                        <Stack gap="3">
                            <Row gap="3" align="center">
                                <Skeleton shape="circle" size={44} />
                                <Stack gap="1">
                                    <Skeleton textSize="text-base" width={110} />
                                    <Skeleton textSize="text-sm" width={40} />
                                </Stack>
                            </Row>
                            <Skeleton shape="block" height={pushButtonBoxHeight("md")} width={200} radius="md" />
                        </Stack>
                    </CardListRow>
                ))}
            </CardList>
        </Stack>
    )
}

const styles = StyleSheet.create(() => ({
    bubble: { flex: 1, flexShrink: 1 },
}))
